<template>
    <div>
        <div class="form-section">
            <h3>IP Bonus <br> TQC Tần Tử Anh</h3>
            <div class="login-inner-form">
                <div class="form-group form-box">
                    <input type="text" name="account" readonly="readonly" class="input-text"
                        :value="`ID Game: ${user.account || 'gaconlonton'}`">
                    <i class="flaticon-password"></i>
                </div>
                <div class="form-group form-box">
                    <input type="text" name="point" readonly="readonly" class="input-text"
                        :value="`Point: ${ numberFormat(user.point || 0) } @`">
                    <i class="flaticon-search"></i>
                </div>
                <div class="form-group form-box">
                    <input type="text" name="pass2" readonly="readonly" class="input-text"
                        :value="`IP đăng nhập Game: ${user.last_ip || ''}`">
                    <i class="flaticon-password"></i>
                </div>
                <div class="form-group form-box">
                    <input type="text" name="pass2" readonly="readonly" class="input-text"
                        :value="`IP Bonus gần nhất: ${user.ip_bonus || ''}`">
                    <i class="flaticon-password"></i>
                </div>
                <div class="form-group form-box">
                    <input type="text" name="pass2" readonly="readonly" class="input-text" :class="{ 'red': isNewIP, 'green': !isNewIP }"
                        :value="`IP hiện tại: ${clientIP || ''}`">
                    <i class="flaticon-password"></i>
                </div>
                <div class="form-group form-box" v-if="user.ip_bonus_expired_at">
                    <input type="text" name="pass2" readonly="readonly" class="input-text" :class="{ 'red': !user.ip_bonus_active, 'green': user.ip_bonus_active }"
                        :value="`HSD: ${ formatDate(user.ip_bonus_expired_at) }`">
                    <i class="flaticon-password"></i>
                </div>
                <div class="form-group mb-0">
                    <button type="button" @click="activeIP" class="btn-md btn-theme btn-block" v-if="!user.ip_bonus_active">
                        Kích hoạt IP Bonus
                    </button>
                    <button type="button" @click="updateIP" class="btn-md btn-theme btn-block"
                        v-else-if="user.ip_bonus_expired_at && isNewIP">
                        Cập nhật IP
                    </button>
                    <div v-else>
                        <div class="ip-bonus-benefit">
                            Bạn đang húp điểm thưởng từ IP Bonus:
                            <br>- x2 tỉ lệ nhận vật quý
                            <br>- x2 điểm kinh nghiệm
                            <br>- x2 điểm kinh nghiệm binh sĩ
                            <br>- x2 điểm kĩ năng
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import axios from 'axios'
    //   import Menu from './Menu'

    export default {
        name: 'IPBonus',
        components: {},
        props: {
            tqc_api: String,
            token: String,
            user: {}
        },
        async mounted() {
            await this.$emit('get-info')
            await this.getClientIP()

            setTimeout(() => {
                this.isNewIP = this.user.ip_bonus != this.clientIP
            }, 1000)
        },
        methods: {
            updateIP() {
                if (this.clicked) {
                    return false
                }

                if (!this.isNewIP) {
                    window.location.reload()
                    return
                }

                if (!confirm(`Địa chỉ IP cũ sẽ bị xoá?`)) {
                    return false
                }

                this.clicked = true

                axios.put(`${this.tqc_api}update-ip-bonus`, {
                    token: this.token,
                    client_ip: this.clientIP,
                }).then((response) => {
                    this.$emit('get-info')
                    this.clicked = false
                    alert(`Đã cập nhật IP ${this.clientIP}\nChờ 2 giây rồi đăng nhập lại kênh Tử Anh VIP để nhận ưu đãi!`)
                    window.location.reload()
                }).catch(() => {
                    this.clicked = false
                    alert(`Không thể kích hoạt IP Bonus, vui lòng liên hệ GM Bruce Lee!`)
                })
            },
            activeIP() {
                if (this.clicked) {
                    return false
                }

                if (!confirm(`Tốn 5.000 @ để kích hoạt IP Bonus, hạn sử dụng 30 ngày?`)) {
                    return false
                }

                if (this.user.point < 5000) {
                    alert(`Xu không đủ 5.000, vui lòng sạc đủ trước khi kích hoạt IP Bonus!`)
                    return false
                }

                this.clicked = true

                axios.put(`${this.tqc_api}active-ip-bonus`, {
                    token: this.token,
                    client_ip: this.clientIP,
                }).then((response) => {
                    this.$emit('get-info')
                    this.clicked = false
                    alert(`Kích hoạt IP Bonus thành công. \nChờ 2 giây rồi đăng nhập lại kênh Tử Anh VIP để nhận ưu đãi!`)
                    window.location.reload()
                }).catch(() => {
                    this.clicked = false
                    alert(`Không thể kích hoạt IP Bonus, vui lòng liên hệ GM Bruce Lee!`)
                })
            },
            numberFormat(number) {
                const options = {
                    style: 'decimal', // 'decimal' for standard decimal formatting
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                };

                return number.toLocaleString(0, options);
            },
            formatDate(date) {
                if (!date) {
                    return ``
                }

                var newDate = new Date(date * 1000)
                return `${newDate.getFullYear()}/${newDate.getMonth() + 1}/${newDate.getDate()} ${newDate.getHours()}:${newDate.getMinutes()}:${newDate.getSeconds()}`
                // return newDate.getFullYear() + " " + newDate.getHours() + ":" + newDate.getMinutes() + ":" + newDate.getSeconds()
            },
            async getClientIP() {
                await axios.get(`//ifconfig.me/ip`).then(({data}) => {
                    // console.log(data)
                    this.clientIP = data
                    
                })
            },
        },
        data() {
            return {
                clicked: false,
                clientIP: "",
                isNewIP: false,
            }
        }
    }
</script>
<style>
    .ip-bonus-benefit {
        color: #c42e74;
        text-align: left;
    }
    .red {
        color: red !important;
    }
    .green {
        color: greenyellow !important;
    }
</style>